import { Container } from '@core/di/Container';
import type { IAuthService } from '@core/auth/types';
import { AuthMethod, UserRole } from '@core/auth/types';

/**
 * Creates the default admin user on first launch if no admin exists.
 * Safe to call on every startup — it's a no-op if the user already exists.
 */
export async function seedDefaultAdmin(): Promise<void> {
  const authService = Container.getInstance().get<IAuthService>('AuthService');

  const existing = await authService.getUserByUsername('admin');
  if (existing) return;

  await authService.createUser({
    username: 'admin',
    email: 'admin@inventorypro.local',
    passwordHash: 'Admin123!',
    role: UserRole.ADMIN,
    permissions: [],
    authMethods: [AuthMethod.PASSWORD],
    failedAttempts: 0,
    locked: false,
    active: true,
  });

  console.info(
    '[Seed] Usuario admin creado. Credenciales por defecto:\n' +
    '  Usuario:    admin\n' +
    '  Contraseña: Admin123!\n' +
    '  ⚠️  Cambiá la contraseña después del primer ingreso.'
  );
}
